<template>
  
  <v-sheet class="rounded-sm">

    <v-toolbar
      dense
      flat
      color     = "primary"
      class     = "routed-t-sm"
    >

      <v-tabs
        color     = "white"
        v-model   = "tab"
      >
        <draggable 
          class     = "d-flex flex-grow-1"
          group     = "tabs"
          :value    = "filteredTabs"
          :disabled = "locked"
          @change   = "onTabsReordered"
        >
          <v-tab
            v-for     = "(tabLabel, index) of filteredTabs"
            :ripple   = "false"
            :key      = "index"
          >
            {{ tabLabel }}
          </v-tab>
        </draggable>
      </v-tabs>

      <TabsMenu
        v-if      = "!locked"
        :value    = "filteredTabs"
        :exclude  = "exclude"
        :hidden   = "hidden"
        @input    = "onTabsChanged"
        @reset    = "onResetTabs"
      >
      </TabsMenu>

    </v-toolbar>

    <!-- Panes -->

    <AnnotationsPane
      v-if    = "activeTab === 'Annotations'"
      class   = "sub-pane"
    >
    </AnnotationsPane>

    <AudioPane
      v-if    = "activeTab === 'Audio'"
      class   = "sub-pane"
    >
    </AudioPane>

    <FrameInfoPane
      v-if    = "activeTab === 'Frame'"
      class   = "sub-pane"
    >
    </FrameInfoPane>

    <ClipsPane
      v-if    = "activeTab === 'Clips'"
      class   = "sub-pane"
    >
    </ClipsPane>

    <ScopesPane
      v-if    = "activeTab === 'Scopes'"
      class   = "sub-pane"
    >
    </ScopesPane>

    <PropertiesPane
      v-if        = "activeTab === 'Inspector'"
      class       = "sub-pane"
      :properties = "video.properties"
      :path       = "videoPath"
    >
    </PropertiesPane>

    <PluginsPane
      v-if    = "activeTab === 'Plugins'"
      class   = "sub-pane"
    >
    </PluginsPane>

  </v-sheet>

</template>

<script>

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import TabsMenu from './components/TabsMenu';
import AnnotationsPane from './AnnotationsPane';
import AudioPane from './AudioPane';
import ClipsPane from './ClipsPane';
import FrameInfoPane from './FrameInfoPane';
import PluginsPane from './PluginsPane.vue';
import PropertiesPane from './PropertiesPane.vue';
import ScopesPane from './ScopesPane';
import {SET_IS_WAVEFORM_FLAG_CLICKED, SET_IS_ANNOTATION_FLAG_CLICKED} from "@/utils/mutation-types";

// #endregion Imports

export default {

  // #region Properties

  name:       'TabbedPane',
  components: {
    AnnotationsPane,
    AudioPane,
    FrameInfoPane,
    ClipsPane,
    PluginsPane,
    PropertiesPane,
    ScopesPane,
    TabsMenu
  },
  props: {
    tabs:    Array,
    exclude: Array,
    hidden:  Array,
    locked:  Boolean
  },
  data() {
    return {
      tab: 0
    };
  },
  computed: {
    ...mapState([
      'video',
      'videoPath',
    ]),
    isWaveformFlagClicked(){
      return this.$store.state.ui.isWaveformFlagClicked;
    },
    isAnnotationFlagClicked(){
      return this.$store.state.ui.isAnnotationFlagClicked;
    },
    filteredTabs() {
      return this.tabs.filter(t => this.hidden ? !this.hidden.includes(t) : true);
    },
    activeTab() {
      return this.tabs[this.tab];
    }
  },

  watch: {
    isWaveformFlagClicked(value){
      if (value){
        let tab = this.tabs.indexOf('Frame');
        if (tab > -1){
          this.tab = tab
        }
      }
      this.$store.commit(SET_IS_WAVEFORM_FLAG_CLICKED, false)
    },
    isAnnotationFlagClicked(value){
      if (value){
        let tab = this.tabs.indexOf('Annotations');
        if (tab > -1){
          this.tab = tab
        }
      }
      this.$store.commit(SET_IS_ANNOTATION_FLAG_CLICKED, false)
    }
  },
  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onTabsChanged(tabs) {
      this.$emit('tabs', tabs);
    },

    onTabsReordered(event) {
      const reorderedTabs = [...this.tabs];

      if (event.moved) {
        const tabRemoved = reorderedTabs.splice(event.moved.oldIndex, 1);
        reorderedTabs.splice(event.moved.newIndex, 0, tabRemoved[0]);
        this.tab = event.moved.newIndex;
      } else if (event.added) {
        reorderedTabs.splice(event.added.newIndex, 0, event.added.element);
        this.tab = event.added.newIndex;
      } else if (event.removed) {
        reorderedTabs.splice(event.removed.oldIndex, 1);
      }

      this.$emit('tabs', reorderedTabs);
    },

    onResetTabs() {
      this.$emit('reset');
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>

<style lang="scss" scoped>

/*
 * The following styles are all in service of having scrollbars appear instead of
 * having the sub-panes resize when they get too big.
 */

.v-sheet {
  overflow:       hidden;
  display:        flex;
  flex-direction: column;

  .v-toolbar {
    flex:           0;
    min-height:     48px;   // TODO: Don't rely on hard-coded value.
  }

  .sub-pane {
    flex:           1;
  }

}

</style>